import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-100 min-h-screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pt-32 text-center text-primary-dark font-bold" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "システムエラーが発生しました"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-10 text-3xl" }, "INTERNAL SERVER ERROR")
], -1)
const _hoisted_3 = { class: "p-4 text-sm text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " 申し訳ありません。お探しのページは一時的にアクセスできない状況です。しばらく経ってからアクセスしてください。 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}